export default __webpack_public_path__ + "static/media/krakenjs.19e94e18.svg";